import { Trip } from '@models';
import { createAction, props } from '@ngrx/store';
import { PageResult } from 'src/app/services/util/query';

// Fetch all Trips
export const fetchTrips = createAction('[Trip] Fetch All Initiated');
export const fetchTripsSuccess = createAction(
  '[Trip] Fetch All Success',
  props<{ trips: PageResult<Trip> }>()
);
export const fetchTripsFailed = createAction(
  '[Trip] Fetch All Failed',
  props<{ error: Error }>()
);

// Fetch Trip by Id
export const fetchTripById = createAction(
  '[Trip] Fetch By Id Initiated',
  props<{ tripId: string }>()
);
export const fetchCurrentTrip = createAction(
  '[Trip] Fetch Current Trip Initiated'
);
export const fetchTripByIdSuccess = createAction(
  '[Trip] Fetch By Id Success',
  props<{ trip: Trip }>()
);
export const fetchTripByIdFailed = createAction(
  '[Trip] Fetch By Id Failed',
  props<{ error: Error }>()
);
